export const languages = [
    "TypeScript",
    "React.js",
    "Next.js",
    "Node.js",
    "GraphQL",
    "PostgreSQL",
];

export const projectsData = [
    {
        title: "Multi-cloud Dashboard Builder",
        company: "OpsLyft",
        about: `Architected a self-service dashboard builder for enterprise SaaS customers, helping teams build cloud visibility workflows without manual reporting. The platform increased daily active users by 2x and reduced manual reporting effort by 70%.`,
        tech: ["React", "TypeScript", "GraphQL", "Vite", "SaaS"],
        impact: "2x DAUs",
    },
    {
        title: "Cost Explorer with AI Anomaly Detection",
        company: "OpsLyft",
        about: `Built a Cost Explorer platform backed by a Node.js service and integrated AWS Bedrock to detect cloud spend anomalies and trigger real-time alerts for engineering and finance teams.`,
        tech: ["Node.js", "AWS Bedrock", "AWS", "Alerts", "Analytics"],
        impact: "Real-time alerts",
    },
    {
        title: "Analytics Migration and Data Aggregation",
        company: "OpsLyft",
        about: `Led a zero-downtime migration from BigQuery to ClickHouse and built high-throughput aggregation services, reducing payload size by 71% and improving API latency by 40%.`,
        tech: ["GraphQL", "ClickHouse", "PostgreSQL", "BigQuery", "Redis"],
        impact: "40% faster APIs",
    },
    {
        title: "EV Purchase and Fulfillment Platform",
        company: "Ola Electric",
        about: `Built end-to-end purchase and fulfillment workflows for EV customers, including warranty, discounts, referrals, test ride bookings, experience center flows, and order lifecycle management.`,
        tech: ["Next.js", "Vue.js", "E-commerce", "Maps", "Logistics"],
        impact: "High-traffic launches",
    },
];

export const blogsData = [
    // {
    //     blogTitle: "blog 2",
    //     blogDiscription:
    //         "Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati, suscipit corrupti sed nesciunt, recusandae quaerat neque consequuntur sint dolores quidem reiciendis dignissimos vitae? Repellat iste sunt nulla atque quisquam ullam.",
    //     blogLink:
    //         "https://santoshcodes.hashnode.dev/what-is-the-difference-between-web-development-and-web-design",
    // },
    {
        blogTitle: "Web Developement Vs Web Design",
        blogDiscription:
            "A web developer is someone who builds and maintains the core structure of a website. They’re tasked with converting the web design into a functional website, using coding languages such as HTML, JavaScript, CSS and Python.",
        blogLink:
            "https://santoshcodes.hashnode.dev/what-is-the-difference-between-web-development-and-web-design",
    },
];
